var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no1"},[_c('div',{staticClass:"no11"},[_vm._t("queryleft")],2),_c('div',[_vm._t("querycenter")],2),_c('div',{staticClass:"no12"},[_vm._t("queryright")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }